(function () {
    const slideshow = () => {
        $(".slideshow-section").each(function () {
            if ($(this).hasClass("slider_started")) {
                return "";
            }
            $(this).addClass("slider_started");
            const id = $(this).attr("id");
            const box = $(this).find(".slideshow");
            const autoplay = box.data("autoplay");
            const stopAutoplay = box.data("stop-autoplay");
            const delay = box.data("delay") * 1000;
            const speed = box.data("speed") * 1000;

            // 检测当前 section 是否全部为视频幻灯片
            const hasVideos = box.find(".swiper-slide video").length > 0;

            if (autoplay) {
                autoplayParm = {
                    autoplay: {
                        // 如果有视频，delay 设超大值，由视频 ended 事件驱动切换
                        delay: hasVideos ? 99999 : delay,
                        pauseOnMouseEnter: stopAutoplay,
                        disableOnInteraction: false,
                        waitForTransition: true,
                    },
                };
            } else {
                autoplayParm = {};
            }

            let swiperParms = {
                parallax: box.data("parallax"),
                effect: box.data("effect"),
                speed: speed,
                loop: false,
                centeredSlides: false,
                autoHeight: false,
                calculateHeight: false,
                keyboard: true,
                creativeEffect: {
                    prev: {
                        shadow: false,
                        translate: [0, 0, -400],
                    },
                    next: {
                        translate: ["100%", 0, 0],
                    },
                },
                coverflowEffect: {
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: false,
                },
                flipEffect: {
                    slideShadows: false,
                },
                pagination: {
                    el: `#${id} .swiper-pagination`,
                    clickable: "true",
                    type: "bullets",
                    renderBullet: function (activeIndex, className) {
                        return (
                            '<span class="' +
                            className +
                            '"><em>' +
                            activeIndex +
                            '</em><i></i><b></b></span>'
                        );
                    },
                },
                ...autoplayParm,
            };

            const swiper = new Swiper(`#${id} .slideshow__swiper`, swiperParms);

            // ─── 视频自动切换逻辑 ──────────────────────────────────────
            if (hasVideos && autoplay) {

                // 播放指定 index 的视频，暂停其他视频
                function playSlideVideo(activeIndex) {
                    const slides = box.find(".swiper-slide");
                    slides.each(function (index) {
                        const video = $(this).find("video")[0];
                        if (!video) return;
                        if (index === activeIndex) {
                            video.currentTime = 0;
                            video.play().catch(() => {}); // 静默处理浏览器拦截
                        } else {
                            video.pause();
                            video.currentTime = 0;
                        }
                    });
                }

                // 绑定视频 ended 事件：播放完自动切换下一张
                function bindVideoEvents() {
                    const slides = box.find(".swiper-slide");
                    slides.each(function (index) {
                        const video = $(this).find("video")[0];
                        if (!video) return;

                        // 移除旧监听，防止重复绑定
                        video.removeEventListener("ended", video._onEnded);
                        video.removeEventListener("error", video._onError);

                        video._onEnded = () => {
                            // 最后一张：回到第一张
                            if (swiper.activeIndex >= swiper.slides.length - 1) {
                                swiper.slideTo(0);
                            } else {
                                swiper.slideNext();
                            }
                        };

                        video._onError = () => {
                            // 视频加载失败时也切换，避免卡住
                            swiper.slideNext();
                        };

                        video.addEventListener("ended", video._onEnded);
                        video.addEventListener("error", video._onError);
                    });
                }

                // 切换 slide 时：播放当前视频
                swiper.on("slideChange", function () {
                    playSlideVideo(swiper.activeIndex);
                });

                // hover 暂停 / 恢复
                if (stopAutoplay) {
                    box.on("mouseenter", function () {
                        const video = box.find(".swiper-slide").eq(swiper.activeIndex).find("video")[0];
                        if (video) video.pause();
                    });
                    box.on("mouseleave", function () {
                        const video = box.find(".swiper-slide").eq(swiper.activeIndex).find("video")[0];
                        if (video) video.play().catch(() => {});
                    });
                }

                // 初始化：绑定事件并播放第一张
                bindVideoEvents();
                playSlideVideo(0);
            }
            // ─── 视频逻辑结束 ──────────────────────────────────────────

            swiper.on("slideChange", function () {
                box.css("--bullet-duration", `${delay + speed}ms`);
            });
            swiper.on("beforeTransitionStart", function () {
                colorScheme(this);
            });
            swiper.on("slideChange", function () {
                colorScheme(this);
            });

            function colorScheme(context) {
                const parent = box.find(".slideshow-bottom");
                const activeIndex = context.activeIndex;
                const activeSlide = context.slides[activeIndex];
                const changeItems = [parent[0]];
                const colorScheme = $(activeSlide)
                    .find(".slideshow-slide")
                    .data("color-scheme");
                changeItems.forEach((item) => {
                    if (!item) return "";
                    const classes = item.classList;
                    for (let className of classes) {
                        if (/color-background-\d+$/.test(className)) {
                            item.classList.remove(className);
                        }
                    }
                    item.classList.add(colorScheme);
                });
            }
        });
    };

    document.addEventListener("DOMContentLoaded", function () {
        slideshow();
        document.addEventListener("shopify:section:load", function () {
            slideshow();
        });
    });
})();
